import { func, object, string } from 'prop-types';
import React from 'react';

import AppliedFilter from './AppliedFilter';

// TODO: Convert to TS when there is more time OMFG-1016 and TOFU-431, but if you see this, feel free to convert it too.
const Color = ({ color, swatchStyle, onClear, className = '' }) => {
  const colorFilter = (
    <React.Fragment>
      <div style={swatchStyle} />
      {`#${color.toUpperCase()}`}
    </React.Fragment>
  );

  return (
    <AppliedFilter
      label={colorFilter}
      onClear={onClear}
      secondaryClassName="Color"
      className={className}
    />
  );
};

Color.propTypes = {
  color: string,
  swatchStyle: object,
  onClear: func,
};

export default Color;
